module.exports = __webpack_public_path__ + "static/img/technologyu02.d2b5ee8d.svg";